var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 164,
    height: 164,
    rx: 82,
    stroke: "#D20B0B",
    strokeOpacity: 0.4,
    strokeWidth: 16,
    "transform-origin": "100 100"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    dur: "2s",
    values: "1;0.79;1",
    repeatCount: "indefinite",
    additive: "replace"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 164,
    height: 164,
    rx: 82,
    stroke: "#D20B0B",
    strokeOpacity: 0.4,
    strokeWidth: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 164,
    height: 164,
    rx: 82,
    stroke: "#D20B0B",
    strokeOpacity: 0.7,
    strokeWidth: 16,
    "transform-origin": "100 100"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    dur: "2s",
    values: "1;0.83;1",
    repeatCount: "indefinite",
    additive: "replace"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 62.5L131.5 74.5V104.5C131.5 118 119.5 131.5 100 137.5C80.5 131.5 68.5 119.5 68.5 104.5V74.5L100 62.5Z",
    fill: "#D20B0B",
    fillOpacity: 0.2,
    stroke: "#D20B0B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 98.5L95.5 107.5L113.5 86.5",
    fill: "#D20B0B",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 98.5L95.5 107.5L113.5 86.5",
    stroke: "#D20B0B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailure);
export default __webpack_public_path__ + "static/media/payment_failure.efd814a37c788dc351e307f80c2a6919.svg";
export { ForwardRef as ReactComponent };